export default state => {
	return state.editClaimSuccess === true;
};
